import { ContentType } from '@/services/contents/types';
import {
  Assignment,
  Audiotrack,
  Circle,
  Image,
  Newspaper,
  SvgIconComponent,
  Videocam,
} from '@mui/icons-material';

const DEFAULT_CONTENT_DETAIL = {
  title: '',
  Icon: Circle,
};

export const getContentDetail = (type?: ContentType) => {
  if (!type) return DEFAULT_CONTENT_DETAIL;

  const details: Record<
    ContentType,
    {
      title: string;
      Icon: SvgIconComponent;
    }
  > = {
    READING: {
      title: 'Lectura',
      Icon: Newspaper,
    },
    AUDIO: {
      title: 'Audio',
      Icon: Audiotrack,
    },
    VIDEO: {
      title: 'Video',
      Icon: Videocam,
    },
    IMAGE: {
      title: 'Imagen',
      Icon: Image,
    },
    QUIZ: {
      title: 'Cuestionario',
      Icon: Assignment,
    },
  };
  return details[type] ?? DEFAULT_CONTENT_DETAIL;
};
